import { render, staticRenderFns } from "./BuildingSocietyFormDetails.vue?vue&type=template&id=7c5a5890&scoped=true&"
import script from "./BuildingSocietyFormDetails.vue?vue&type=script&lang=js&"
export * from "./BuildingSocietyFormDetails.vue?vue&type=script&lang=js&"
import style0 from "./BuildingSocietyFormDetails.vue?vue&type=style&index=0&id=7c5a5890&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5a5890",
  null
  
)

export default component.exports